import * as React from "react";
import { useTranslation } from "react-i18next";

import { AuthCard, ForgotPasswordForm } from "@/components/auth";

export function ForgotPasswordPage() {
  const { t } = useTranslation("auth");

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <AuthCard title={t("forgotPassword.title")} description={t("forgotPassword.subtitle")}>
        <ForgotPasswordForm />
      </AuthCard>
    </div>
  );
}

export default ForgotPasswordPage;
